import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import { makeStyles, Container, Box, Typography } from '@material-ui/core';
import PropTypes__default from 'prop-types';
import FaqCore from './FaqCore.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { retrieveContentfulImage } from '../../common/image.js';

var useStyles = makeStyles(function (theme) {
  return {
    container: _defineProperty({
      backgroundColor: "#F8F8F3",
      display: "flex",
      justifyContent: "center",
      padding: theme.spacing(10, 0)
    }, theme.breakpoints.down("sm"), {
      padding: theme.spacing(7.5, 0)
    }),
    mainTitle: _defineProperty({
      width: "100%",
      textAlign: "center",
      padding: theme.spacing(0, 2),
      margin: theme.spacing(2.5, 0, 11.25, 0)
    }, theme.breakpoints.down("sm"), {
      marginBottom: theme.spacing(9)
    }),
    mainImg: {
      width: theme.spacing(17.5),
      height: theme.spacing(17.5)
    }
  };
});
var Faq = function Faq(_ref) {
  var imageTitle = _ref.imageTitle,
    imageUrl = _ref.imageUrl,
    title = _ref.title,
    elements = _ref.elements;
  var classes = useStyles();
  return /*#__PURE__*/React__default.createElement(Container, {
    maxWidth: false,
    className: classes.container
  }, /*#__PURE__*/React__default.createElement(Box, {
    width: "100%",
    maxWidth: 600,
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center"
  }, imageUrl && /*#__PURE__*/React__default.createElement(LazyLoadImage, {
    className: classes.mainImg,
    src: retrieveContentfulImage(imageUrl, {
      width: 140,
      height: 140
    }),
    alt: imageTitle || ""
  }), title && /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h1",
    component: "h2",
    className: classes.mainTitle
  }, title), elements && /*#__PURE__*/React__default.createElement(FaqCore, {
    elements: elements
  })));
};
Faq.propTypes = {
  title: PropTypes__default.string,
  elements: PropTypes__default.array,
  imageTitle: PropTypes__default.string,
  imageUrl: PropTypes__default.string
};

export { Faq as default };
//# sourceMappingURL=Faq.js.map
